export default __webpack_public_path__ + "static/media/icons.bf824edc.svg";